import Vue from 'vue'
if (!window.dashboardbus) {
  window.dashboardbus = new Vue({});
}
export default window.dashboardbus;



// WEBPACK FOOTER //
// ./src/bus.js